import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import ErrorBoundary from "./components/ErrorBoundary";
import "./index.css";
import "./i18n";

// Initialize Sentry asynchronously after the app mounts to avoid blocking FCP/LCP.
// See App.tsx useEffect for deferred initialization.
// import { initSentry } from "./lib/sentry"; // removed: now called from App.tsx

// Gestión de errores de carga de chunks dinámicos (stale chunk tras nuevo deploy en producción).
// Vite emite el evento 'vite:preloadError' al fallar la descarga de un módulo importado vía lazy/dynamic import.
window.addEventListener("vite:preloadError", () => {
  const retryKey = "brickshare_preload_retry";
  const lastRetry = sessionStorage.getItem(retryKey);
  const now = Date.now();

  // Si no se ha recargado en los últimos 15 segundos, forzar recarga limpia para traer el index.html y assets actualizados.
  if (!lastRetry || now - Number(lastRetry) > 15000) {
    sessionStorage.setItem(retryKey, String(now));
    window.location.reload();
  }
});

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    {/* Boundary de nivel superior: un error de render no debe dejar la app en blanco */}
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </HelmetProvider>
);

// Registrar Service Worker para soporte PWA en producción
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((registration) => {
      if (import.meta.env.DEV) {
        console.log('SW registrado con éxito:', registration.scope);
      }
    }).catch((error) => {
      if (import.meta.env.DEV) {
        console.error('Error al registrar SW:', error);
      }
    });
  });
}

